(function () {
  'use strict';

  angular.module('ConventionModule', ['ui.bootstrap']);

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  /* eslint-plugin-disable angular/file-name */
  angular.module('ConventionModule', ['ngAnimate']).config(['$locationProvider', function ($locationProvider) {
    $locationProvider.html5Mode({
      enabled: true,
      requireBase: false,
      rewriteLinks: true
    });
  }]).controller('ConventionController', ['$scope', '$window', '$location', '$timeout', ConventionController]).filter('trusted', ['$sce', function ($sce) {
    return $sce.trustAsResourceUrl;
  }]).filter('baseText', [function () {
    return function (string) {
      if (!angular.isString(string)) {
        return string;
      }

      return string.replace(/[^a-zA-Z]/g, '').toLowerCase();
    };
  }]);

  function ConventionController($scope, $window, $location, $timeout) {
    var cv = this;
    var conventionDataUpdates = $window.ConventionDataUpdates || {};
    cv.labels = _objectSpread2(_objectSpread2({}, ConventionData), conventionDataUpdates);
    cv.pcd = $window.PageClientData;

    if (typeof curSession !== 'undefined') {
      $scope.currentIframe = cv.labels.watch.iframes[curSession];
    }

    if (typeof curMig !== 'undefined') {
      $scope.currentMigIframe = cv.labels.migIframes[curMig];
    }

    var GTMid = null;
    var GTMtabs = [349, 350, 351, 356, 357]; // about, schedule, speakers, celebration corner, watch

    var GTMtabsLoaded = [360, 362, 361, 364, 363]; // about, schedule, speakers, celebration corner, watch

    $scope.loading = true;
    $scope.openCaptions = false;

    $scope.toggler = function (id) {
      $scope.openCaptions = !$scope.openCaptions;
      angular.element(id).toggleClass('active');
    };

    $timeout(function () {
      $scope.isMobile = isMobile;
      $scope.celebrationOrder = $scope.isMobile ? 'morder' : '';
      $scope.activeTab = 0;
      var urlParams = $location.search();
      $scope.urlTab = urlParams.tab;

      if ($scope.urlTab && $scope.urlTab !== '') {
        //URL param takes presidence
        $scope.urlTabNum = cv.labels.tabs.findIndex(function (tab) {
          return tab.href === $scope.urlTab;
        });
        $scope.activeTab = $scope.urlTabNum;
      } else {
        //default
        $scope.urlTab = 'about';
        $scope.urlTabNum = 0;
      }

      if (typeof trackAction === 'function') {
        trackAction({
          id: GTMtabsLoaded[$scope.urlTabNum]
        });
      }
      /* galaCrossover represents a timeframe where the only change
      on the page is the Celebration Corner. This was easier than
      using timespans */


      var galaCrossover = angular.element('.o-celebration-top').hasClass('-mig');

      if (galaCrossover) {
        angular.element('.o-conv-header').addClass('--celebration');
        angular.element('.m-conv-logo').attr('alt', cv.labels.celebration.alt);
      }

      $scope.headerImg = $scope.urlTab == 'celebration' ? galaCrossover ? isMobile ? cv.labels.header.mcelebrationbg : cv.labels.header.celebrationbg : cv.labels.header.galabg : $scope.urlTab == 'workshops' ? cv.labels.header.workshopsbg : cv.labels.header.bg;
      $scope.events = {};
      angular.forEach(ConventionSchedule, function (value, key) {
        $scope.events[key] = _objectSpread2(_objectSpread2({}, ConventionSchedule[key]), UpdateButtons[key]);
      });
      $scope.anchor = false;

      $scope.goToLink = function (e, link, title) {
        e.preventDefault();

        if (typeof trackAction === 'function') {
          trackAction({
            id: 353,
            eL: title
          }); // GTM
        }

        window.history.pushState(null, $scope.urlTab, $location.url());
        window.location.replace(link);
      };

      $scope.setActive = function (e, elem) {
        e.preventDefault();
        $scope.urlTab = cv.labels.tabs[elem].href;

        if (e.currentTarget.nodeName == 'BUTTON') {
          GTMid = 353;
        } else {
          GTMid = GTMtabs[elem];
        }

        if (typeof trackAction === 'function') {
          trackAction({
            id: GTMid,
            eL: e.currentTarget.innerText
          }); // GTM

          trackAction({
            id: GTMtabsLoaded[elem]
          });
        }

        $location.url('/businesscenter/securecontent/events_MenuHolder_2?tab=' + $scope.urlTab);
        $location.replace('/businesscenter/securecontent/events_MenuHolder_2?tab=' + $scope.urlTab);
        window.history.pushState(null, $scope.urlTab, $location.url());
        $scope.activeTab = elem;
        $scope.headerImg = $scope.urlTab == 'celebration' ? galaCrossover ? isMobile ? cv.labels.header.mcelebrationbg : cv.labels.header.celebrationbg : cv.labels.header.galabg : $scope.urlTab == 'workshops' ? cv.labels.header.workshopsbg : cv.labels.header.bg;

        if (!$scope.anchor) {
          angular.element('html,body').animate({
            scrollTop: angular.element('.navbar').offset().top
          });
        }

        if ($scope.urlTab == 'celebration') {
          $('.js-slick-slider').slick('slickGoTo', 0);
        }
      };

      $scope.setActiveAndAnchor = function (e, elem, anchor) {
        e.preventDefault();
        $scope.anchor = true;
        $scope.setActive(e, elem);
        $timeout(function () {
          var mobileOffset = $('#mobile-header') ? $('#mobile-header').height() : 0;
          angular.element('#speakers li[data-for="' + anchor + '"]').addClass('hilite');
          $('html,body').animate({
            scrollTop: angular.element('#speakers li[data-for="' + anchor + '"]').offset().top - mobileOffset
          });
        }, 100);
        $timeout(function () {
          angular.element('#speakers li[data-for="' + anchor + '"]').removeClass('hilite');
          $scope.anchor = false;
        }, 2500);
      };

      $scope.toTop = function () {
        $('html,body').animate({
          scrollTop: 0
        });
      }; // Celebration Carousel


      $('.js-slick-slider').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        pauseOnHover: true,
        pauseOnDotsHover: true,
        autoplay: false,
        autoplaySpeed: 4000,
        dots: true,
        customPaging: function customPaging(slider, i) {
          return '<i class="fa fa-circle" aria-hidden="true"></i>';
        }
      });
      $('.js-slick-slider').on('setPosition', function (slick) {
        $('#carousel').css('opacity', '1');
      });
      $('body').on('click', '.slick-arrow', function (e) {
        if (typeof trackAction === 'function') {
          trackAction({
            id: 29,
            eL: e.currentTarget.innerText
          }); // GTM
        }
      });

      if (isMobile) {
        $scope.loading = false;
        $(window).on('load resize', function () {
          if (angular.element('.m-celebration-carousel--img').length > 0) {
            var imgH = angular.element('.m-celebration-carousel--img')[0].height + 20;

            if (imgH > 50) {
              angular.element('.slick-dots').css('top', imgH + 'px');
              angular.element('.slick-dots i.fa').fadeIn();
            }
          }
        });
      }

      $window.addEventListener('load', function () {
        $scope.loading = false;
        $scope.$digest();
        $('.js-slick-slider').on('beforeChange', function (event, slick, currentSlide) {
          $window.dispatchEvent(new Event('resize'));
        });
        $('.js-slick-slider').slick('slickPlay');
        var vert = ['top', 'center', 'bottom'];

        $timeout(function () {
          angular.forEach(angular.element('.m-earners-a'), function (v, i) {
            var randV = vert[Math.floor(Math.random() * vert.length)];
            var min = 0;
            var max = -255;
            var randV = Math.random() * (max - min) + min;

            angular.element(v)[0].style.backgroundPosition = 'center ' + randV + 'px';

            if (angular.element(v)[0].offsetHeight > 95) {
              angular.element(v).addClass('-tall');
            }
          });
        });

        if (isMobile) {
          // Move the workout buttons on mobile
          angular.forEach(ConventionSchedule.d2e1.buttonUrls, function (v, i) {
            var origTag = angular.element('[ng-data-insert="' + i + '"]');
            var spanTag = angular.element('.' + i);
            angular.forEach(spanTag, function (v, i) {
              angular.element(v).html(origTag[i]);
            });
          });
        }
      });
    });
  }

  /* eslint-plugin-disable angular/johnpapa */
  setTimeout(function () {
    angular.bootstrap($(document)[0].getElementById('Convention'), ['ConventionModule', 'sharedService', 'ngWmUtil']);
  }, 100);

}());
